

export const CONTROL_EVENT = 'CONTROL_EVENT';
